import Cookies from 'js-cookie'
import { handleRequest } from '../services'
import router from '../router/index'

export default {
  setAuthorization: ({ commit }, payload) => {
    commit('authorization', payload)
  },
  userInfo: async ({ commit }, payload) => {
    async function requestPersonalInfo () {
      let response
      try {
        response = await handleRequest.get('personal/short')
      } catch (err) {
        response = {error: err}
      }
      return response
    }

    function clearCookies () {
      Cookies.remove('CompMan')
      Cookies.remove('comp_man')
      Cookies.remove('UserId')
      Cookies.remove('Authorization')
    }

    const isLocal = window.location.hostname.includes('localhost')

    if (payload) {
      let response = await requestPersonalInfo()
      if (response.error) {
        let response = await requestPersonalInfo()

        if (response.error) {
          clearCookies()
          if (isLocal) {
            payload('/login')
          } else {
            window.location.href = 'http://paper.pontotel.com.br'
          }
          return false
        }
      }

      Cookies.set('CompMan', response.data.success['0'].compMan.id)
      Cookies.set('UserId', response.data.success['0'].id)
      commit('userInfo', response.data.success['0'])
      return response.data.success['0']
    } else {
      clearCookies()
      if (isLocal) {
        router.push('/login')
      } else {
        window.location.href = 'http://paper.pontotel.com.br'
      }
    }
  },
  setCurrentFolhaDigit: ({ commit }, payload) => {
    commit('currentFolhaDigit', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js